import React from "react";
import scalable from "../../assets/cloud_mgmt/scalability.png";
import efficiency from "../../assets/cloud_mgmt/reduce-cost.png";
import security from "../../assets/cloud_mgmt/cyber-security.png";
import collaboration from "../../assets/cloud_mgmt/collaboration.png";
import recovery from "../../assets/cloud_mgmt/disaster-recovery_new.png";
import operations from "../../assets/cloud_mgmt/operational-system.png";
import flexibility from "../../assets/cloud_mgmt/flexibility_new.png";
import innovation from "../../assets/cloud_mgmt/project-management.png";

const CloudMgmtBenefits = () => {
  return (
    <div className="mt-10">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Benefits of Cloud Management Service
      </p>
      <div className="flex flex-col items-center justify-between mt-5">
        <div className="flex w-full px-5 sm:px-28 justify-between">
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={scalable} className="w-8 sm:w-14" />
            Scalability
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={efficiency} className="w-8 sm:w-14" />
            Cost Efficiency
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={security} className="w-8 sm:w-14" />
            Enhanced Security
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={collaboration} className="w-8 sm:w-14" />
            Improved Collaboration
          </p>
        </div>

        <div className="flex w-full px-5 sm:px-28 justify-between mt-5">
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={recovery} className="w-8 sm:w-14" />
            Disaster Recovery and Business Continuity
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={operations} className="w-8 sm:w-14" />
            Efficient Operations Governance
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={flexibility} className="w-8 sm:w-14" />
            Geographic Flexibility
          </p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={innovation} className="w-8 sm:w-14" />
            Continuous Innovation
          </p>
        </div>
      </div>
    </div>
  );
};

export default CloudMgmtBenefits;
